// Types
import { CheckerboardConfig } from './types';

// Theme
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

const {
  rawColors: { scrollingTileBackground },
} = employeeYearInReviewTheme;

/**
 * Gradient pattern for 4x2 tile groups
 * Each tile gets a unique linear-gradient to create depth variation
 * Row 0: tiles 1-4, Row 1: tiles 5-8
 */
export const GRADIENT_PATTERN = [
  // Row 0 (top): positions 0-3
  [
    'linear-gradient(180deg, #0A397D 0%, #1368E3 71.95%)',
    'linear-gradient(180deg, #1368E3 28.05%, #0A397D 100%)',
    'linear-gradient(180deg, #0A397D 0%, #1368E3 71.95%)',
    'linear-gradient(180deg, #1368E3 28.05%, #0A397D 100%)',
  ],
  // Row 1 (bottom): positions 4-7
  [
    'linear-gradient(180deg, #0A397D 0%, #1368E3 71.95%)',
    'linear-gradient(180deg, #1368E3 28.05%, #0A397D 100%)',
    'linear-gradient(180deg, #0A397D 0%, #1368E3 71.95%)',
    'linear-gradient(180deg, #1368E3 28.05%, #0A397D 80%)',
  ],
];

export const PATTERN_COLS = 4;
export const PATTERN_ROWS = 2;

export const DEFAULT_CONFIG: CheckerboardConfig = {
  tileSize: 850,
  borderRadius: 60,
  gap: 2,
  rotation: -10,
  rotationSpeed: 1, // 2 degrees per second for slow rotation
  speed: 1.5,
  tileColor: scrollingTileBackground.tileColor,
  backgroundColor: scrollingTileBackground.backgroundColor,
};
